const userApps = {
  actions: {
    details: '查看 {{name}} 详情',
    detailsShort: '详情',
    favorite: '收藏 {{name}}',
    install: '添加应用',
    installNamed: '添加 {{name}} 到我的应用',
    installShort: '添加',
    remove: '移除应用',
    removeNamed: '移除 {{name}}',
    removeShort: '移除',
    unfavorite: '取消收藏 {{name}}',
    use: '立即使用',
  },
  detail: {
    close: '关闭应用详情',
    instructions: '应用使用说明：',
  },
  empty: {
    filtered: '未找到相关应用',
    goMarket: '前往应用广场',
    market: '应用广场暂无可添加应用',
    mine: '你还没有从应用广场添加过应用',
  },
  emptyDescription: '暂无应用说明',
  emptyVersion: '暂无版本',
  errors: {
    forbidden: '当前账号没有权限访问这些应用。',
    channelUnavailable: '此应用未在当前使用渠道开放。',
    listDescription: '应用列表暂时不可用，请稍后重试。',
    listTitle: '应用加载失败',
    operationDescription: '操作未完成，请稍后重试。',
    operationTitle: '操作失败',
    unauthorized: '登录状态已失效，请重新登录。',
  },
  filters: {
    all: '所有',
  },
  feedback: {
    favoriteSuccess: '已收藏应用',
    installSuccess: '已添加到我的应用',
    removeSuccess: '已移除应用',
    unfavoriteSuccess: '已取消收藏',
  },
  loading: '应用加载中',
  moreTags: '...',
  removeConfirm: {
    cancel: '取消',
    close: '关闭移除确认',
    confirm: '确认移除',
    description: '确定要将 {{name}} 从我的应用中移除吗？移除后仍可在应用广场重新添加。',
    title: '移除应用',
  },
  search: {
    label: '搜索应用',
    placeholder: '搜索应用',
    placeholderMobile: '按名称搜索应用',
  },
  tabs: {
    market: '应用广场',
    mine: '我的应用',
  },
}

export default userApps
